const languageColors = {
  LANGUAGE_50: '#FFEAED',
  LANGUAGE_100: '#FFCBCF',
  LANGUAGE_200: '#F09795',
  LANGUAGE_700: '#D32523',
}

export default languageColors
